export default class DisplayInformation {
  constructor({ name, colorSVG, displayName, iconColor }) {
    this.name = name;
    this.colorSVG = colorSVG || `${name}-color.svg`;
    this.displayName = displayName;
    this.iconColor = iconColor || `${name}-icon-color.svg`;
  }
}
